import { buildDevtoolsThemeBlock } from "../core/StringDevStyleSystem";

export function buildGridCSS(): string {
  return `
    ${buildDevtoolsThemeBlock(["[data-string-grid-root]", "[data-string-grid-chrome]"])}

    [data-string-grid-root],
    [data-string-grid-chrome] {
      --string-grid-overlay-z-index: 10010;
      --string-grid-trigger-z-index: 10011;
      --string-grid-panel-z-index: 10012;
      --string-grid-trigger-size: 28px;
      --string-grid-trigger-gap: 8px;
      --string-grid-trigger-opacity-idle: 0;
      --string-grid-trigger-opacity-visible: 1;
      --string-grid-trigger-opacity-open: 1;
      --string-grid-stack-offset: 0px;
      --string-grid-panel-offset-top: 0px;
      --string-grid-panel-width: 200px;
      --string-grid-panel-height: auto;
      --string-grid-panel-max-height: 60vh;
      --string-grid-panel-padding: var(--string-dev-panel-padding);
      --string-grid-panel-bg: var(--string-dev-panel-bg);
      --string-grid-panel-bg-strong: #f0f0f0;
      --string-grid-panel-border: var(--string-dev-panel-border);
      --string-grid-panel-radius: var(--string-dev-panel-radius);
      --string-grid-panel-shadow: var(--string-dev-panel-shadow);
      --string-grid-panel-dropdown-shadow: 0 16px 24px rgba(0, 0, 0, 0.1);
      --string-grid-panel-backdrop: var(--string-dev-panel-backdrop);
      --string-grid-panel-font-family: var(--string-dev-panel-font-family);
      --string-grid-panel-font-size: var(--string-dev-panel-font-size);
      --string-grid-panel-text: var(--string-dev-panel-text);
      --string-grid-panel-muted: var(--string-dev-panel-muted);
      --string-grid-panel-subtle: var(--string-dev-panel-subtle);
      --string-grid-panel-faint: rgba(17, 17, 17, 0.38);
      --string-grid-panel-divider: var(--string-dev-panel-divider);
      --string-grid-panel-divider-strong: rgba(17, 17, 17, 0.1);
      --string-grid-header-font-size: var(--string-dev-header-font-size);
      --string-grid-header-font-weight: var(--string-dev-header-font-weight);
      --string-grid-header-letter-spacing: var(--string-dev-header-letter-spacing);
      --string-grid-header-padding: var(--string-dev-header-padding);
      --string-grid-header-margin-bottom: var(--string-dev-header-margin-bottom);
      --string-grid-row-gap: 8px;
      --string-grid-row-padding: 6px 8px;
      --string-grid-row-radius: 8px;
      --string-grid-row-hover-bg: rgba(221, 221, 221, 0.24);
      --string-grid-row-border: rgba(255, 255, 255, 0.9);
      --string-grid-settings-indent: 0px;
      --string-grid-accent: var(--string-dev-accent);
      --string-grid-accent-soft: var(--string-dev-accent-soft);
      --string-grid-accent-soft-hover: var(--string-dev-accent-soft-hover);
      --string-grid-accent-border: rgba(255, 79, 54, 0.32);
      --string-grid-accent-border-hover: rgba(255, 79, 54, 0.54);
      --string-grid-accent-focus: var(--string-dev-focus-color);
      --string-grid-accent-focus-soft: rgba(255, 79, 54, 0.18);
      --string-grid-accent-strong: var(--string-dev-accent);
      --string-grid-danger: #111111;
      --string-grid-font-mono: "JetBrains Mono", monospace;
      --string-grid-field-label-color: #111111;
      --string-grid-field-value-color: rgba(17, 17, 17, 0.72);
      --string-grid-field-value-color-active: #111111;
      --string-grid-field-bg: var(--string-dev-field-bg);
      --string-grid-field-bg-soft: rgba(221, 221, 221, 0.22);
      --string-grid-field-border: var(--string-dev-field-border);
      --string-grid-field-border-soft: var(--string-dev-field-border);
      --string-grid-field-radius: var(--string-dev-field-radius);
      --string-grid-field-radius-sm: 6px;
      --string-grid-toggle-off: rgba(17, 17, 17, 0.18);
      --string-grid-toggle-on: var(--string-grid-accent);
      --string-grid-toggle-knob: #ffffff;
      --string-grid-option-bg: #ffffff;
      --string-grid-option-text: var(--string-grid-panel-text);
      --string-grid-scrollbar-size: 4px;
      --string-grid-scrollbar-thumb: rgba(17, 17, 17, 0.16);
      --string-grid-scrollbar-thumb-hover: rgba(17, 17, 17, 0.24);
      --string-grid-number-columns: minmax(0, 75px) 28px;
      --string-grid-range-columns: minmax(0, 40px) auto 28px;
      --string-grid-range-no-unit-columns: minmax(0, 75px) 28px;
      --string-grid-unit-width: 32px;
      --string-grid-input-height: var(--string-dev-input-height);
      --string-grid-field-font-size: var(--string-dev-panel-font-size);
      --string-grid-field-font-size-sm: var(--string-dev-panel-font-size);
      --string-grid-universal-radius: var(--string-dev-field-radius);
      --string-grid-universal-border: transparent;
      --string-grid-universal-bg: transparent;
      --string-grid-universal-bg-hover: transparent;
      --string-grid-universal-divider: rgba(17, 17, 17, 0.15);
      --string-grid-universal-shadow: none;
      --string-grid-side-panel-gap: 8px;
      --string-grid-hud-inset: 12px;
    }

    [data-string-grid-overlay] {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: var(--string-grid-overlay-z-index);
      overflow: hidden;
    }

    [data-string-grid-trigger] {
      position: absolute;
      top: 0;
      left: 0;
      width: var(--string-grid-trigger-size, 28px);
      height: var(--string-grid-trigger-size, 28px);
      z-index: var(--string-grid-trigger-z-index, 10011);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: auto;
      transition: opacity 0.2s ease, background 0.2s ease;
      border: 1px solid rgba(255, 255, 255, 0.92);
      border-radius: 8px;
      background: rgba(224, 224, 224, 0.92);
      box-shadow: 0 12px 16px rgba(0, 0, 0, 0.05);
      padding: 5px;
      box-sizing: border-box;
      color: #111;
    }

    [data-string-grid-trigger][data-state="idle"] {
      opacity: var(--string-grid-trigger-opacity-idle, 0);
    }

    [data-string-grid-trigger][data-state="visible"] {
      opacity: var(--string-grid-trigger-opacity-visible, 1);
    }

    [data-string-grid-trigger][data-state="open"] {
      opacity: var(--string-grid-trigger-opacity-open, 1);
    }

    [data-string-grid-trigger] svg {
      width: 16px;
      height: 16px;
    }

    [data-string-grid-trigger]:hover {
      background: rgba(255, 255, 255, 0.98);
    }

    [data-string-grid-chrome] {
      position: absolute;
      top: 0;
      left: 0;
      width: var(--string-grid-trigger-size, 28px);
      height: var(--string-grid-trigger-size, 28px);
      pointer-events: auto;
      overflow: visible;
      z-index: var(--string-grid-panel-z-index);
    }

    [data-string-grid-hud],
    [data-string-grid-side-panel] {
      position: absolute;
      top: 0;
      width: var(--string-grid-panel-width);
      max-height: var(--string-grid-panel-max-height);
      overflow-y: auto;
      z-index: var(--string-grid-panel-z-index);
      opacity: 0;
      transform: translateY(4px);
      transition: opacity 0.2s ease, transform 0.2s ease;
      pointer-events: none;
      box-sizing: border-box;
      overflow-x: hidden;
    }

    [data-string-grid-hud] {
      right: calc(var(--string-grid-trigger-size) + var(--string-grid-trigger-gap));
    }

    [data-string-grid-side-panel] {
      right: calc(
        var(--string-grid-trigger-size) +
        var(--string-grid-trigger-gap) +
        var(--string-grid-panel-width) +
        var(--string-grid-side-panel-gap)
      );
    }

    [data-string-grid-trigger][data-open="true"] ~ [data-string-grid-hud] {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    [data-string-grid-side-panel][data-open="true"] {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
    }

    [data-string-grid-header-action] {
      width: 16px;
      height: 16px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    [data-string-grid-header-action] {
      padding: 0;
      border: 0;
      background: transparent;
      color: var(--string-grid-panel-text);
      cursor: pointer;
    }

    [data-string-grid-header-action][data-passive="true"] {
      cursor: default;
      opacity: 0.9;
    }

    [data-string-grid-header-action] svg {
      width: 16px;
      height: 16px;
    }

    [data-string-grid-list] {
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    [data-string-grid-empty-add] {
      justify-content: flex-start;
    }

    [data-string-grid-empty-add-icon] {
      width: 16px;
      height: 16px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    [data-string-grid-empty-add-label] {
      font-size: 12px;
      font-weight: 500;
    }

    [data-string-grid-list-item] {
      min-height: 32px;
      display: grid;
      grid-template-columns: 16px 16px minmax(0, 1fr) auto 20px;
      align-items: center;
      column-gap: 8px;
      padding: 6px 8px;
      border: 1px solid var(--string-grid-field-border);
      border-radius: 8px;
      background: var(--string-grid-field-bg);
      cursor: pointer;
      transition: opacity 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    }

    [data-string-grid-list-item] + [data-string-grid-list-item] {
      margin-top: 2px;
    }

    [data-string-grid-list-item][data-state="selected"] {
      background: rgba(221, 221, 221, 0.2);
    }

    [data-string-grid-list-item][data-state="disabled"] {
      color: rgba(17, 17, 17, 0.45);
    }

    [data-string-grid-list-item][data-dragging="true"] {
      opacity: 0.48;
    }

    [data-string-grid-list-item][data-drop="before"] {
      box-shadow: inset 0 2px 0 var(--string-grid-accent);
    }

    [data-string-grid-list-item][data-drop="after"] {
      box-shadow: inset 0 -2px 0 var(--string-grid-accent);
    }

    [data-string-grid-list-label] {
      font-size: 12px;
      font-weight: 500;
      color: inherit;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    [data-string-grid-list-icon],
    [data-string-grid-add-grid-icon] {
      width: 16px;
      height: 16px;
      align-items: center;
      justify-content: center;
      display: inline-flex;
      color: currentColor;
    }

    [data-string-grid-list-delete] {
      width: 20px;
      height: 20px;
      padding: 0;
      border: 0;
      border-radius: 999px;
      background: #ffffff;
      color: var(--string-grid-panel-text);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    [data-string-grid-list-delete] svg {
      width: 16px;
      height: 16px;
    }

    [data-string-grid-list-toggle] {
      width: 22px;
      height: 14px;
      border-radius: 999px;
      background: var(--string-grid-toggle-off);
      display: inline-flex;
      align-items: center;
      position: relative;
      cursor: pointer;
    }

    [data-string-grid-toggle-input] {
      display: none;
    }

    [data-string-grid-toggle] {
      width: 22px;
      height: 14px;
      border-radius: 999px;
      background: var(--string-grid-toggle-off);
      display: inline-flex;
      align-items: center;
      position: relative;
      cursor: pointer;
    }

    [data-string-grid-toggle][data-checked="true"] {
      background: var(--string-grid-toggle-on);
    }

    [data-string-grid-toggle-knob] {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--string-grid-toggle-knob);
      position: absolute;
      top: 2px;
      left: 2px;
      transition: left 0.2s ease;
    }

    [data-string-grid-toggle][data-checked="true"] [data-string-grid-toggle-knob] {
      left: 10px;
    }

    [data-string-grid-list-toggle][data-checked="true"] {
      background: var(--string-grid-toggle-on);
    }

    [data-string-grid-list-toggle-knob] {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--string-grid-toggle-knob);
      position: absolute;
      top: 2px;
      left: 2px;
      transition: left 0.2s ease;
    }

    [data-string-grid-list-toggle][data-checked="true"] [data-string-grid-list-toggle-knob] {
      left: 10px;
    }

    [data-string-grid-drag-handle],
    [data-string-grid-header-action] {
      width: 16px;
      height: 16px;
      padding: 0;
      border: 0;
      background: transparent;
      color: var(--string-grid-panel-subtle);
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.15s ease;
    }

    [data-string-grid-drag-handle] {
      color: rgba(17, 17, 17, 0.16);
      cursor: grab;
    }

    [data-string-grid-drag-handle]:active {
      cursor: grabbing;
    }

    [data-string-grid-drag-handle] svg,
    [data-string-grid-list-delete] svg,
    [data-string-grid-header-action] svg {
      width: 16px;
      height: 16px;
    }

    [data-string-grid-add-grid-list] {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0;
    }

    [data-string-grid-add-grid-item] {
      justify-content: flex-start;
    }

    [data-string-grid-add-grid-item]:nth-child(n + 3) {
      margin-top: 2px;
    }

    [data-string-grid-add-grid-label] {
      font-size: 12px;
      font-weight: 500;
    }

    [data-string-grid-detail-content] {
      display: block;
    }

    [data-string-grid-settings-container] {
      display: flex;
      flex-direction: column;
      gap: 2px;
      padding: 0;
    }

    [data-string-grid-field-row] {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: center;
      gap: 0;
      min-height: 32px;
      padding: 0 0px 0 8px;
      min-width: 0;
      border: 1px solid var(--string-grid-field-border);
      border-radius: 8px;
      background: var(--string-grid-field-bg);
      overflow: hidden;
    }

    [data-string-grid-field-label] {
      font-size: 12px;
      color: var(--string-grid-field-label-color);
      font-family: var(--string-grid-panel-font-family);
      user-select: none;
      white-space: nowrap;
      min-width: 0;
      display: flex;
      align-items: center;
    }

    [data-string-grid-field-input],
    [data-string-grid-field-select] {
      min-height: var(--string-grid-input-height);
      font-size: var(--string-grid-field-font-size);
      font-family: var(--string-grid-panel-font-family);
      background: var(--string-grid-field-bg);
      border: 1px solid var(--string-grid-field-border);
      border-radius: var(--string-grid-field-radius);
      color: var(--string-grid-panel-text);
      outline: none;
      box-sizing: border-box;
    }

    [data-string-grid-field-input] {
      width: 100%;
      font-size: 12px;
      font-family: var(--string-grid-panel-font-family);
      font-weight: 500;
      color: var(--string-grid-field-value-color-active);
      text-align: center;
    }

    [data-string-grid-field-select] {
      cursor: pointer;
    }

    [data-string-grid-field-input]:focus,
    [data-string-grid-field-select]:focus,
    [data-string-grid-field-unit]:focus {
      border-color: var(--string-grid-accent-focus);
    }

    [data-string-grid-field-select] option,
    [data-string-grid-field-unit] option {
      background: var(--string-grid-option-bg);
      color: var(--string-grid-option-text);
    }

    [data-string-grid-field-range-right] {
      display: flex;
      align-items: center;
      gap: 0;
      min-width: 0;
      justify-content: flex-end;
      min-height: 100%;
      border-left: 1px solid var(--string-grid-universal-divider);
    }

    [data-string-grid-number-input],
    [data-string-grid-range-input] {
      display: grid;
      align-items: center;
      width: auto;
      max-width: 100%;
      min-width: 0;
      min-height: 100%;
      border: 0;
      border-radius: 0;
      background: var(--string-grid-universal-bg);
      box-shadow: var(--string-grid-universal-shadow);
      overflow: hidden;
      box-sizing: border-box;
      justify-self: end;
    }

    [data-string-grid-number-input] {
      grid-template-columns: var(--string-grid-number-columns);
    }

    [data-string-grid-range-input] {
      grid-template-columns: var(--string-grid-range-columns);
    }

    [data-string-grid-range-input][data-has-unit="false"] {
      grid-template-columns: var(--string-grid-range-no-unit-columns);
    }

    [data-string-grid-field-row] > [data-string-grid-number-input],
    [data-string-grid-field-row] > [data-string-grid-range-input],
    [data-string-grid-field-row] > [data-string-grid-select-shell],
    [data-string-grid-field-row] > [data-string-grid-color-shell] {
      min-height: 100%;
      border-left: 1px solid var(--string-grid-universal-divider);
    }

    [data-string-grid-input-value-wrap],
    [data-string-grid-input-unit-wrap] {
      min-width: 0;
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
    }

    [data-string-grid-input-value-wrap] {
      padding: 0 0px;
    }

    [data-string-grid-input-unit-wrap] {
      border-left: 1px solid var(--string-grid-universal-divider);
      min-width: var(--string-grid-unit-width);
      padding: 0 6px;
    }

    [data-string-grid-stepper-stack] {
      display: grid;
      grid-template-rows: 1fr 1fr;
      min-height: 100%;
      border-left: 1px solid var(--string-grid-universal-divider);
    }

    [data-string-grid-number-input] [data-string-grid-field-input],
    [data-string-grid-range-input] [data-string-grid-field-value],
    [data-string-grid-range-input] [data-string-grid-field-unit] {
      background: transparent;
      border: 0;
      border-radius: 0;
      box-shadow: none;
    }

    [data-string-grid-field-value] {
      width: 100%;
      min-height: calc(var(--string-grid-input-height) - 4px);
      padding: 0;
      font-size: 12px;
      font-family: var(--string-grid-panel-font-family);
      font-weight: 500;
      color: var(--string-grid-field-value-color-active);
      background: transparent;
      border: 0;
      border-radius: 0;
      text-align: left;
      outline: none;
      transition: border-color 0.15s ease, color 0.15s ease;
      box-sizing: border-box;
      text-align: center;
    }

    [data-string-grid-stepper-btn] {
      width: 100%;
      min-width: 0;
      min-height: 0;
      padding: 0;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: var(--string-grid-panel-text);
      font-size: 12px;
      line-height: 1;
      cursor: pointer;
      transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.15s ease, color 0.15s ease;
    }

    [data-string-grid-stepper-btn][data-direction="up"] {
      border-bottom: 1px solid var(--string-grid-universal-divider);
    }

    [data-string-grid-stepper-btn]:hover,
    [data-string-grid-stepper-btn]:focus-visible {
      background: rgba(255, 255, 255, 0.3);
      color: var(--string-grid-panel-text);
      outline: none;
    }

    [data-string-grid-stepper-icon] {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      color: rgba(17, 17, 17, 0.72);
    }

    [data-string-grid-stepper-icon] svg {
      width: 100%;
      height: 100%;
    }

    [data-string-grid-field-value]:focus {
      color: var(--string-grid-field-value-color-active);
    }

    [data-string-grid-field-unit] {
      width: 100%;
      min-height: calc(var(--string-grid-input-height) - 4px);
      padding: 0;
      font-size: 12px;
      font-family: var(--string-grid-panel-font-family);
      font-weight: 500;
      color: var(--string-grid-panel-text);
      background: transparent;
      border: 0;
      border-radius: 0;
      outline: none;
      cursor: pointer;
      appearance: none;
      -webkit-appearance: none;
      text-align: center;
      text-align-last: center;
    }

    [data-string-grid-select-shell],
    [data-string-grid-color-shell] {
      display: grid;
      align-items: center;
      width: 104px;
      max-width: 100%;
      min-height: 100%;
      border: 0;
      border-radius: 0;
      background: var(--string-grid-universal-bg);
      box-shadow: var(--string-grid-universal-shadow);
      overflow: hidden;
      box-sizing: border-box;
      justify-self: end;
      position: relative;
    }

    [data-string-grid-select-shell] {
      grid-template-columns: minmax(0, 1fr) 32px;
    }

    [data-string-grid-color-shell] {
      grid-template-columns: 38px minmax(0, auto);
    }

    [data-string-grid-select-value-wrap] {
      min-width: 0;
      padding: 0 8px;
      pointer-events: none;
    }

    [data-string-grid-select-display] {
      display: block;
      width: 100%;
      font-size: 12px;
      font-family: var(--string-grid-panel-font-family);
      color: var(--string-grid-field-value-color-active);
      line-height: calc(var(--string-grid-input-height) - 4px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    [data-string-grid-select-shell] [data-string-grid-field-select] {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      opacity: 0;
      border: 0;
      outline: none;
      appearance: none;
      -webkit-appearance: none;
      cursor: pointer;
    }

    [data-string-grid-select-indicator] {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      min-height: 100%;
      border-left: 1px solid var(--string-grid-universal-divider);
      color: rgba(17, 17, 17, 0.72);
      pointer-events: none;
    }

    [data-string-grid-select-indicator] svg {
      width: 14px;
      height: 14px;
    }

    [data-string-grid-color-shell] {
      column-gap: 0;
    }

    [data-string-grid-color-swatch-wrap] {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      min-height: 100%;
      border-right: 1px solid var(--string-grid-universal-divider);
      pointer-events: none;
    }

    [data-string-grid-color-input] {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      padding: 0;
      cursor: pointer;
      border: 0;
    }

    [data-string-grid-color-swatch] {
      width: 16px;
      height: 16px;
      border-radius: 999px;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.96);
    }

    [data-string-grid-color-value] {
      min-width: 65px;
      padding: 0 0 0 8px;
      font-size: 12px;
      font-family: var(--string-grid-panel-font-family);
      font-weight: 500;
      color: var(--string-grid-panel-text);
      text-align: left;
      pointer-events: none;
    }

    [data-string-grid-divider] {
      height: 4px;
    }

    [data-string-grid-divider-label] {
      display: none;
      font-family: var(--string-grid-panel-font-family);
      color: var(--string-grid-panel-subtle);
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    [data-string-grid-hud]::-webkit-scrollbar {
      width: var(--string-grid-scrollbar-size);
    }
    [data-string-grid-hud]::-webkit-scrollbar-track {
      background: transparent;
    }
    [data-string-grid-hud]::-webkit-scrollbar-thumb {
      background: var(--string-grid-scrollbar-thumb);
      border-radius: 2px;
    }
    [data-string-grid-hud]::-webkit-scrollbar-thumb:hover {
      background: var(--string-grid-scrollbar-thumb-hover);
    }

    [data-string-grid-layout-selector] {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      min-width: 0;
    }

    [data-string-grid-layout-name] {
      font-size: var(--string-grid-header-font-size);
      font-weight: var(--string-grid-header-font-weight);
      color: var(--string-grid-panel-text);
      letter-spacing: var(--string-grid-header-letter-spacing);
      line-height: 1.2;
      max-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    [data-string-grid-layout-arrow] {
      width: 12px;
      height: 12px;
      padding: 0;
      border: 0;
      background: transparent;
      color: var(--string-grid-panel-muted);
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: color 0.15s ease;
    }

    [data-string-grid-layout-arrow] svg {
      width: 12px;
      height: 12px;
      transition: transform 0.2s ease;
    }

    [data-string-grid-layout-arrow][data-open="true"] svg {
      transform: rotate(180deg);
    }

    [data-string-grid-layout-dropdown] {
      display: none;
      flex-direction: column;
      gap: 2px;
      padding: 0 4px 6px;
      border-bottom: 1px solid var(--string-grid-panel-divider);
      margin-bottom: 4px;
    }

    [data-string-grid-layout-dropdown][data-open="true"] {
      display: flex;
    }

    [data-string-grid-layout-list] {
      display: flex;
      flex-direction: column;
      gap: 1px;
      margin-bottom: 4px;
    }

    [data-string-grid-layout-item] {
      min-height: 28px;
      display: grid;
      grid-template-columns: 1fr 20px;
      align-items: center;
      gap: 4px;
      padding: 0 4px;
      border-radius: 6px;
      background: transparent;
      cursor: default;
    }

    [data-string-grid-layout-item][data-active="false"] {
      cursor: pointer;
    }

    [data-string-grid-layout-item]:hover {
      background: var(--string-grid-row-hover-bg);
    }

    [data-string-grid-layout-item][data-active="true"] {
      background: var(--string-grid-accent-soft);
    }

    [data-string-grid-layout-item-name] {
      font-size: 12px;
      font-weight: 500;
      color: var(--string-grid-panel-text);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    [data-string-grid-layout-item-name-input] {
      width: 100%;
      font-size: 12px;
      font-weight: 500;
      font-family: var(--string-grid-panel-font-family);
      color: var(--string-grid-panel-text);
      background: transparent;
      border: 0;
      border-bottom: 1px solid var(--string-grid-accent);
      outline: none;
      padding: 0;
    }

    [data-string-grid-layout-item-rename] {
      width: 20px;
      height: 20px;
      padding: 0;
      border: 0;
      background: transparent;
      color: var(--string-grid-panel-muted);
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      flex-shrink: 0;
      transition: opacity 0.15s ease;
    }

    [data-string-grid-layout-item]:hover [data-string-grid-layout-item-rename] {
      opacity: 1;
    }

    [data-string-grid-layout-item-rename] svg {
      width: 10px;
      height: 10px;
    }

    [data-string-grid-layout-add] {
      justify-content: flex-start;
      margin-top: 1px;
    }

    [data-string-grid-layout-add-icon] {
      width: 10px;
      height: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    [data-string-grid-layout-add-icon] svg {
      width: 16px;
      height: 16px;
    }

    [data-string-grid-layout-name-input] {
      width: 100%;
      max-width: 110px;
      background: transparent;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-bottom: 1px solid var(--string-grid-accent);
      padding: 0;
      min-height: auto;
      border-radius: 0;
      box-shadow: none;
      text-align: center;
      line-height: 1.2;
    }

    [data-string-grid-detail-title-input] {
      width: 100%;
      max-width: 120px;
      background: transparent;
      border-top: 0;
      border-left: 0;
      border-right: 0;
      border-bottom: 1px solid var(--string-grid-accent);
      padding: 0;
      min-height: auto;
      border-radius: 0;
      box-shadow: none;
      text-align: center;
      line-height: 1.2;
    }

    [data-string-grid-layout-name] {
      cursor: pointer;
    }

    [data-string-grid-detail-title] {
      cursor: pointer;
    }

    [data-string-grid-layout-io-row] {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4px;
      margin-top: 4px;
      padding-top: 4px;
      border-top: 1px solid var(--string-grid-panel-divider);
    }

    [data-string-grid-io-btn] {
      width: 100%;
      justify-content: flex-start;
    }

    [data-string-grid-layout-chip-row] {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      padding: 2px 8px 10px;
    }

    [data-string-grid-layout-chip] {
      min-width: 28px;
      min-height: 28px;
      padding: 0 10px;
      border: 0;
      border-radius: 999px;
      background: rgba(17, 17, 17, 0.06);
      color: rgba(17, 17, 17, 0.72);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.08em;
      cursor: pointer;
      font-family: var(--string-grid-panel-font-family);
    }

    [data-string-grid-layout-chip-action="settings"] {
      color: rgba(17, 17, 17, 0.86);
    }

    [data-string-grid-layout-chip-action="settings"][data-open="true"] {
      color: var(--string-grid-accent);
    }

    [data-string-grid-layout-chip][data-selected="true"] {
      color: var(--string-grid-accent);
    }

    [data-string-grid-layout-settings] {
      padding: 0 0 8px;
    }

    [data-string-grid-layout-settings-list] {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    [data-string-grid-layout-range] {
      --string-grid-layout-range-first: 28%;
      --string-grid-layout-range-second: 64%;
      --string-grid-layout-range-medium: 28%;
      --string-grid-layout-range-large: 64%;
      --string-grid-layout-range-handle-gap: 24px;
      display: grid;
      gap: 8px;
      padding: 0px 12px 12px;
    }

    [data-string-grid-layout-range-labels] {
      position: relative;
      height: 12px;
    }

    [data-string-grid-layout-range-value] {
      position: absolute;
      top: 0;
      min-width: 44px;
      padding: 0;
      border: 0;
      background: transparent;
      color: rgba(17, 17, 17, 0.6);
      font-family: var(--string-grid-panel-font-family);
      font-size: 11px;
      font-weight: 600;
      line-height: 1;
      cursor: pointer;
      transform: translateX(-50%);
    }

    [data-string-grid-layout-range-value][data-handle="m"] {
      left: var(--string-grid-layout-range-first);
    }

    [data-string-grid-layout-range-value][data-handle="l"] {
      left: var(--string-grid-layout-range-second);
    }

    [data-string-grid-layout-range-track] {
      position: relative;
      min-height: 42px;
      border-radius: 12px;
      background: #DDDDDD;
      overflow: visible;
    }

    [data-string-grid-layout-range-track][data-state="active"] {

    }

    [data-string-grid-layout-range-track][data-state="dragging"] {

    }

    [data-string-grid-layout-range-segment] {
      position: absolute;
      top: 0;
      bottom: 0;
      padding: 0;
      border: 0;
      background: transparent;
      color: #000000;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-family: var(--string-grid-panel-font-family);
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
    }
    [data-string-grid-layout-range-segment]:hover {
      background: #F1F1F1;
    }

    [data-string-grid-layout-range-segment][data-mode="S"] {
      left: 0;
      width: var(--string-grid-layout-range-medium);
      border-radius: 12px 0 0 12px;
    }

    [data-string-grid-layout-range-segment][data-mode="M"] {
      left: var(--string-grid-layout-range-medium);
      width: calc(var(--string-grid-layout-range-large) - var(--string-grid-layout-range-medium));
    }

    [data-string-grid-layout-range-segment][data-mode="L"] {
      left: var(--string-grid-layout-range-large);
      width: calc(100% - var(--string-grid-layout-range-large));
      border-radius: 0 12px 12px 0;
    }

    [data-string-grid-layout-range-segment][data-selected="true"] {
      color: var(--string-grid-accent);
    }


    [data-string-grid-layout-range-divider] {
      position: absolute;
      top: -6px;
      bottom: -14px;
      width: 18px;
      padding: 0;
      border: 0;
      background: transparent;
      transform: translateX(-50%);
      cursor: ew-resize;
      touch-action: none;
    }

    [data-string-grid-layout-range-divider]::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 12px;
      left: 50%;
      width: 2px;
      border-radius: 999px;
      background: rgba(17, 17, 17, 0.9);
      transform: translateX(-50%);
    }

    [data-string-grid-layout-range-divider][data-handle-state="active"]::before {

    }

    [data-string-grid-layout-range-divider][data-handle-state="dragging"]::before {

    }

    [data-string-grid-layout-range-divider][data-handle="m"] {
      left: var(--string-grid-layout-range-first);
    }

    [data-string-grid-layout-range-divider][data-handle="l"] {
      left: var(--string-grid-layout-range-second);
    }

    [data-string-grid-layout-range-knob] {
      position: absolute;
      top: calc(100% + 2px);
      width: 8px;
      height: 8px;
      border-radius: 999px;
      background: #111111;
      border: 0;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
      transform-origin: top center;
      transform: translate(-50%, -50%) scale(1);
      transition: transform 0.15s ease;
      cursor: ew-resize;
      touch-action: none;
    }

    [data-string-grid-layout-range-knob][data-handle="m"] {
      left: var(--string-grid-layout-range-first);
    }

    [data-string-grid-layout-range-knob][data-handle="l"] {
      left: var(--string-grid-layout-range-second);
    }

    [data-string-grid-layout-range-knob]::after {
      content: "";
      position: absolute;
      inset: -8px;
    }

    [data-string-grid-layout-range-knob][data-handle-state="active"] {
      transform: translate(-50%, -50%) scale(1.2);
    }

    [data-string-grid-layout-range-knob][data-handle-state="dragging"] {
      transform: translate(-50%, -50%) scale(1.4);
    }

    [data-string-grid-layout-range-editor] {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) auto;
      align-items: center;
      min-height: 42px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.96);
      border: 1px solid rgba(17, 17, 17, 0.08);
      overflow: hidden;
    }

    [data-string-grid-layout-range-editor][data-state="active"] {

    }

    [data-string-grid-layout-range-editor][data-state="dragging"] {

    }

    [data-string-grid-layout-range-editor-prefix] {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 42px;
      padding: 0 14px;
      color: rgba(17, 17, 17, 0.42);
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.06em;
    }

    [data-string-grid-layout-range-editor-prefix] svg {
      width: 14px;
      height: 14px;
      display: block;
    }

    [data-string-grid-layout-range-editor-input] {
      min-width: 0;
      width: 100%;
      padding: 0 12px;
      border: 0;
      background: transparent;
      color: var(--string-grid-panel-text);
      text-align: center;
      font-family: var(--string-grid-panel-font-family);
      font-size: 14px;
      font-weight: 600;
      outline: none;
      appearance: textfield;
      -moz-appearance: textfield;
    }

    [data-string-grid-layout-range-editor-input]::-webkit-outer-spin-button,
    [data-string-grid-layout-range-editor-input]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    [data-string-grid-layout-range-editor-suffix] {
      align-self: stretch;
      display: inline-flex;
      align-items: center;
      padding: 0 8px;
      border-left: 1px solid #D1D1D1;
      color: #888888;
      font-size: 12px;
    }

    [data-string-grid-empty-add] {
      font-size: 12px;
    }

    [data-string-grid-empty-add-label] {
      font-size: 12px;
      font-weight: 500;
    }

    [data-string-grid-list-item] {
      grid-template-columns: 16px minmax(0, 1fr) auto 20px;
      min-height: 32px;
      padding: 8px 10px;
      border-radius: 12px;
    }

    [data-string-grid-list] {

    }

    [data-string-grid-list-item] + [data-string-grid-list-item] {
      margin-top: 0;
    }

    [data-string-grid-list-delete] {
      background: transparent;
    }
  `;
}
